import { Link } from 'react-router-dom';
import { hotMovies } from '@/mocks/movies';

export default function HeroSection() {
  const featuredMovie = hotMovies[0];

  return (
    <section className="relative w-full h-[600px] md:h-[700px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20interior%20with%20dramatic%20warm%20golden%20spotlight%20beams%2C%20elegant%20red%20velvet%20curtains%20and%20seats%2C%20atmospheric%20smoke%20and%20fog%2C%20luxurious%20and%20grand%20cinema%20aesthetic%2C%20professional%20photography%20with%20soft%20shadows%20and%20rich%20contrast%2C%20dark%20background%20with%20warm%20golden%20accents&width=1800&height=900&seq=hero-bg-cinema&orientation=landscape"
        alt="星空影院 - 热播电影推荐"
        title="星空影院 - 热播电影与院线电影同步在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background-50"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
            <div className="flex-shrink-0 w-48 md:w-56 lg:w-64">
              <img
                src={featuredMovie.coverImage}
                alt={`${featuredMovie.title} 电影海报`}
                title={`${featuredMovie.title} - 星空影院热播推荐`}
                className="w-full rounded-lg shadow-2xl"
              />
            </div>

            <div className="flex-1 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 text-primary-400 text-xs font-medium mb-4">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-fire-line text-sm"></i>
                </div>
                热播排行榜 TOP 1
              </div>
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-50 mb-3">
                {featuredMovie.title}
              </h1>
              <p className="text-sm md:text-base text-foreground-300 mb-4 max-w-xl">
                {featuredMovie.englishTitle}
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-4">
                <span className="px-3 py-1 rounded-full bg-background-100/80 border border-background-300/50 text-xs text-foreground-300 whitespace-nowrap">
                  {featuredMovie.year}
                </span>
                <span className="px-3 py-1 rounded-full bg-background-100/80 border border-background-300/50 text-xs text-foreground-300 whitespace-nowrap">
                  {featuredMovie.region}
                </span>
                <span className="px-3 py-1 rounded-full bg-background-100/80 border border-background-300/50 text-xs text-foreground-300 whitespace-nowrap">
                  {featuredMovie.duration}
                </span>
                <div className="flex items-center gap-1 px-3 py-1 rounded-full bg-accent-500/20 border border-accent-500/30">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                  </div>
                  <span className="text-xs font-semibold text-accent-400 whitespace-nowrap">{featuredMovie.rating}</span>
                </div>
              </div>
              <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-6 max-w-2xl line-clamp-3">
                {featuredMovie.description}
              </p>
              <div className="flex items-center justify-center lg:justify-start gap-3">
                <Link
                  to={`/movie/${featuredMovie.id}`}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm cursor-pointer whitespace-nowrap hover:bg-primary-600 transition-colors"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-play-circle-fill text-base"></i>
                  </div>
                  立即观看
                </Link>
                <Link
                  to="/category/all"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-100/80 border border-background-300/50 text-foreground-100 font-medium text-sm cursor-pointer whitespace-nowrap hover:border-primary-500/50 transition-colors"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-movie-2-line text-base"></i>
                  </div>
                  浏览全部
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Link
        to="#category-nav"
        className="absolute bottom-6 left-1/2 -translate-x-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-background-100/60 border border-background-300/40 cursor-pointer hover:bg-background-200/60 transition-colors animate-bounce"
      >
        <i className="ri-arrow-down-s-line text-foreground-300 text-lg"></i>
      </Link>
    </section>
  );
}